import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { ApiServicesService } from '../services/api-services.service';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/services/company.service';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Store } from '@ngrx/store';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { UserService } from '../../../services/user.service';
import { LoginService } from '../../login/login.service';

@Component({
  selector: 'app-create-bene',
  templateUrl: './create-bene.component.html',
  styleUrls: ['./create-bene.component.scss']
})
export class CreateBeneComponent implements OnInit, AfterViewInit, OnDestroy {
  inviteBeneForm: FormGroup;
  inviteExternalBeneForm: FormGroup;
  listCompany;
  isSubmitted = false;
  formChangesSubscription: any;
  closeResult = '';
  @Input() public beneficiary;
  @Output() refreshList: EventEmitter<any> = new EventEmitter();
  @ViewChild('inviteBene', { static: false }) inviteBene: NgForm;
  formDirty = false;
  public pwd_hide = false;
  observableSubscription$ = new Subject();
  autoGeneratedId : boolean = false;

  constructor(
    private toastr: ToastrService,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private apiService: ApiServicesService,
    private companyApiService: CompanyService,
    public dialog: MatDialog,
    protected store: Store<any>,
    private loginService: LoginService,
    private userService: UserService
    ) { this.createForm(); }

  private createForm() {
    this.inviteBeneForm = this.formBuilder.group({
      company: ['', [Validators.required]],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      middlename: '',
      email: ['', [Validators.required, Validators.email]]
    });

    this.inviteExternalBeneForm = this.formBuilder.group({
      company: ['', [Validators.required]],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      middlename: '',
      userId: ['', [Validators.required]],
      communicationEmailId: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.companyApiService.getCompanyHierarchyById(parseInt(sessionStorage.getItem('companyId'))).pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
      this.listCompany = data;
    });
    // IM-3352 (IM-3335) user story
    if (this.beneficiary) {
      this.inviteBeneForm.patchValue({
        company: this.beneficiary.companyId ? this.beneficiary.companyId : '',
        firstname: this.beneficiary.beneficiaryEmployeeFName ? this.beneficiary.beneficiaryEmployeeFName : '',
        lastname: this.beneficiary.beneficiaryEmployeeLName ? this.beneficiary.beneficiaryEmployeeLName : '',
        middlename: this.beneficiary.beneficiaryEmployeeMName ? this.beneficiary.beneficiaryEmployeeMName : '',
        email: this.beneficiary.beneficiaryEmail ? this.beneficiary.beneficiaryEmail : ''
      });
    }
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.inviteBene.statusChanges.subscribe(() => {
      if (this.inviteBene.dirty) {
        this.formDirty = true;
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      }
      else {
        this.formDirty = false;
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  // inviteBeneFormSub() {
  //   const payload = {
  //     "companyId": this.inviteBeneForm.value.company,
  //     "emailId": this.inviteBeneForm.value.email,
  //     "firstName": this.inviteBeneForm.value.firstname,
  //     "lastName": this.inviteBeneForm.value.lastname,
  //     "middleName": this.inviteBeneForm.value.middlename ? this.inviteBeneForm.value.middlename : '',
  //     "note": ""
  //   }

  //   this.apiService.sendBeneficiaryInvite(payload).subscribe(result => {
  //     if (result) {
  //       this.store.dispatch(new MarkCleanFormAction({
  //         dirty: false
  //       }));
  //       this.toastr.success('Invite sent successfully', 'Success');
  //       this.refreshList.emit('Success');  //IM-3352 (IM-3335) user story
  //       this.activeModal.close(); // IM-3340 related,autoclose only on success
  //     }

  //   });


  // }

  inviteExternalBeneFormSub() {
    try {
      const payload = {
        companyId: this.inviteExternalBeneForm.value.company,
        firstName: this.inviteExternalBeneForm.value.firstname,
        lastName: this.inviteExternalBeneForm.value.lastname,
        middleName: this.inviteExternalBeneForm.value.middlename ? this.inviteExternalBeneForm.value.middlename : '',
        userId: this.inviteExternalBeneForm.value.userId,
        password: '',
        emailId: this.inviteExternalBeneForm.value.communicationEmailId,
        note: '',
        id: 0
      };

      this.apiService.sendBeneficiaryInvite(payload).subscribe(result => {
        try {
          if (result.status === 200) {
            this.store.dispatch(new MarkCleanFormAction({
              dirty: false
            }));
            this.toastr.success(result.message, 'Success');
            this.refreshList.emit('Success');  // IM-3352 (IM-3335) user story
            this.activeModal.close(); // IM-3340 related,autoclose only on success
          }
        } catch (error) {
          console.log(error);
        }
      });
    } catch (error1) {
      console.log(error1);
    }
  }
  // IM-3352 (IM-3335) user story done by jeeva 09-10-2020


  closeInviteForm() {
    if (this.formDirty) {
      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.activeModal.dismiss('Cross click');
          this.formDirty = false;
        }
      });
    } else {
      this.activeModal.dismiss('Cross click');
    }

  }

  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  setUserIdValidity(flag) {
    if (flag) {
      this.inviteExternalBeneForm.controls['userId'].setErrors(null);
    } else {
      this.inviteExternalBeneForm.controls['userId'].setErrors({ mustMatch: true });
      return false;
    }
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  generateUniqueUsername(popover){
    let fullNameArray = [this.inviteExternalBeneForm.get('firstname').value,this.inviteExternalBeneForm.get('lastname').value];

    // if(this.inviteExternalBeneForm.get('firstname').value === '' || this.inviteExternalBeneForm.get('lastname').value === '') return;

    if(this.inviteExternalBeneForm.get('userId').value || fullNameArray.length < 2) return;
    
    if(this.inviteExternalBeneForm.get('middlename').value){
      fullNameArray.push(this.inviteExternalBeneForm.get('middleName').value);
    }
    const userId = this.userService.getUserName(fullNameArray);

    this.loginService.checkUserIdAvailability(userId).pipe(takeUntil(this.observableSubscription$)).subscribe((response)=> {
      if(response && response.status === 200){
        if(response.data.available){
          this.autoGeneratedId = true;
          const userIdControl = this.inviteExternalBeneForm.get('userId');
          userIdControl.setValue(userId);
          userIdControl.markAsDirty();
          userIdControl.updateValueAndValidity();
          this.setUserIdValidity(true);
          popover.open();
        }else{
          this.generateUniqueUsername(popover);
        }
      }
    })
  }

  onChangeUserId(){
    this.autoGeneratedId = false;
  }

}
